import { isBeta, isDev, isStage } from '@fond-of/env'

export const useShopify = (host: string) => {
  if (isDev(host) || isBeta(host)) {
    return true
  }

  if (isStage(host) && import.meta.env.PUBLIC_BRAND === 'ergobag') {
    return true
  }

  return import.meta.env.PUBLIC_BRAND === 'satch'
}
